import { render, staticRenderFns } from "./CajaSelectComponent.vue?vue&type=template&id=08373b40&"
import script from "./CajaSelectComponent.vue?vue&type=script&lang=js&"
export * from "./CajaSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports